import { Card } from "reactstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Currency, { ConvertCurrency } from "../../helpers/Currency/Currency";
import { convertRoleToPath, sumWallets } from "../../utils";

const WalletSection = ({ wallet }) => {
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.auth);
  const type = wallet.type;

  if (!user.wallet) return;

  return (
    <Card body className={`${wallet.theme ? wallet.theme : 'bg-gradient'} rounded-3xl text-light p-5`}>
      <div className={`justify-between align-center fs-16px`}>
        {wallet.type !== 'none' ? <p className="m-0">کیف پول {wallet.value}</p> : <p className="m-0">موجودی رفاهیتو</p>}
        <img
          src="/assets/images/logo-second.png"
          alt="logo"
          width={26}
          height={26}
          style={{ boxShadow: '0 0 25px 5px rgba(251, 86, 7, 0.4)' }}
          className="rounded-xl"
        />
      </div>
      <p className='d-flex align-center'>
        <span className={`fa-2x text-white mr-2`}>
          <ConvertCurrency price={type !== 'none' ? user.wallet[type] : sumWallets(user.wallet)} />
        </span>{" "}
        <Currency isNormal />
      </p>
      <div className={`justify-between align-center fs-16px`}>
        <p className="m-0">
          از{" "}
          <span className="text-white ml-1">
            <ConvertCurrency price={sumWallets(user.wallet)} />
          </span>
        </p>
        <Link
          className="text-white fw-bold"
          to={`/${convertRoleToPath(auth.role)}/profile`}
        >
          مشاهده جزئیات
        </Link>
      </div>
    </Card>
  );
};

export default WalletSection;
